/* eslint no-console: "off", quotes: "off" */
import { mapGetters } from 'vuex';

/**
 * Created by tpetridis on 23/3/2021.
 */

const StaticWinnersMixin = {
  methods: {
    /* eslint-disable */
    winnersListMethod() {
      let winnersList = [];
      for (let k=1; k<=50; k++) { // see if exist for 20 similar keys
        if (this.getTranslations[`winners_static_user_name.${k}`]){ // check that name exists
          winnersList.push({
            date: (this.getTranslations[`winners_static_user_date.${k}`]) ? this.getTranslations[`winners_static_user_date.${k}`] : null, // validations if something is missing
            msisdn: (this.getTranslations[`winners_static_user_msisdn.${k}`]) ? this.getTranslations[`winners_static_user_msisdn.${k}`] : null,
            name: (this.getTranslations[`winners_static_user_name.${k}`]) ? this.getTranslations[`winners_static_user_name.${k}`] : null,
            prize: (this.getTranslations[`winners_static_user_prize.${k}`]) ? this.getTranslations[`winners_static_user_prize.${k}`] : null });
        }
      }
      return winnersList;
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};

export default StaticWinnersMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/winnersStaticHtmlViaTranslations.js